import { Component } from '@angular/core';
import { BreadcrumbComponent } from '../../shared/breadcrumb/breadcrumb.component';
import { NgxLoadingModule } from '@dchtools/ngx-loading-v18';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { UtilService } from '../../services/util.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-password',
  imports: [BreadcrumbComponent, FormsModule, NgxLoadingModule],
  templateUrl: './create-password.component.html',
  styleUrl: './create-password.component.css',
})
export class CreatePasswordComponent {
  currentBreadcrumb = ['Log In', 'Create Password'];
  email!: string;
  constructor(
    private api: ApiService,
    private util: UtilService
  ) {}

    async createPasswordLink() {
      console.log("clicked");
      try {
        // this.loading = true;
        this.util.setLoder(true)
        let res = await this.api.createPassword(this.email);
        if (res.message) {
          Swal.fire({
            title: "Success",
            text: `${res.message}`,
            icon: "success"
          });
          this.email = ''
          // this.loading = false;
          this.util.setLoder(false)
        }
      } catch (error) {
        console.log(error);
        // this.loading = false;
        this.util.setLoder(false)
        this.util.showQuotesToast('Error', 'error', 'User Not Found.');
      }
    }
}
